import { invariantResponse } from '@epic-web/invariant'
import { MDXProvider } from '@mdx-js/react'
import { type LoaderFunctionArgs, useParams } from 'react-router'
import { getArticleBySlug } from '#app/features/writing/articles.ts'
import { mdxComponents } from '#app/features/writing/mdx-components.tsx'
import { type Route } from './+types/writing.$slug.ts'

export async function loader({ params }: LoaderFunctionArgs) {
	const article = getArticleBySlug(params.slug ?? '')
	invariantResponse(article, 'Article not found', { status: 404 })
	// Return only serializable metadata — the rendered MDX component can't cross
	// the loader -> component boundary, so the component re-resolves it.
	const { Component: _Component, ...meta } = article
	return { article: meta }
}

export const meta: Route.MetaFunction = ({ data }) => {
	if (!data?.article) return [{ title: 'Not found · slvr.mn' }]
	return [
		{ title: `${data.article.title} · slvr.mn` },
		{ name: 'description', content: data.article.description },
	]
}

export default function WritingPost() {
	const { slug } = useParams()
	const article = getArticleBySlug(slug ?? '')
	// The loader has already 404'd on a missing slug, so this is always defined.
	if (!article) return null
	const Article = article.Component
	return (
		<MDXProvider components={mdxComponents}>
			<main className="font-poppins">
				<Article />
			</main>
		</MDXProvider>
	)
}
